import PageHead from '@/components/header/PageHead';
import BeneficiaryToOwnerUpgrade from '@/components/BeneficiaryToOwnerUpgrade';
export default {
  name: "SubPoolInductionPage",
  components: {
    PageHead,
    BeneficiaryToOwnerUpgrade
  },
  data() {
    return {
      nodeId: ''
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.nodeId = this.$route.params.provider;
    }
  },
  computed: {
    docsUrlPrefix() {
      return `https://docs.stfil.io/${this.$i18n.locale === "zh" ? 'v/cn/' : ''}`;
    }
  }
};